import { useQuery } from "@tanstack/react-query";
import { competitionRepository } from "@/config/dataSource";

export function useCompetitions() {
  return useQuery({
    queryKey: ["competitions"],
    queryFn: () => competitionRepository.getCompetitions(),
    staleTime: 60 * 60 * 1000, // 1h — competições mudam raramente
  });
}
